import Spec from "./components/Spec";
import {
  addNavMenuItem,
  registerBulkAction,
  registerFormInputComponent,
  registerPageTab,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";

import { registerReactCustomDetailComponent } from "@bb-vendure/admin-ui/react";
import { deleteBulkAction } from "./components/bulkAction";
import { deleteBulkAction as noticeDeleteBulkAction } from "./components/default-product-description/list/list-bulk-actions";
import { deleteBulkAction as translationDeleteBulkAction } from "./components/default-product-description-translation/list/list-bulk-actions";
import { DefaultProductDescriptionTranslationListComponent } from "./components/default-product-description-translation/list/list.component";
import { DescSelectComponent } from "./components/select/select.component";

export default [
  registerFormInputComponent("desc-select", DescSelectComponent),
  registerPageTab({
    location: "default-product-description-list" as PageLocationId,
    tab: "Translations",
    route: "translations",
    component: DefaultProductDescriptionTranslationListComponent,
  }),
  addNavMenuItem(
    {
      id: "default-product-info",
      label: "Default Product Information",
      routerLink: ["/extensions/default-product-information"],
      icon: "note",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadDefaultProductInformation");
      },
    },
    "settings"
  ),
  addNavMenuItem(
    {
      id: "default-product-description",
      label: "nav.mandatory-product-notices",
      routerLink: ["/extensions/mandatory-product-notices"],
      icon: "note",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadDefaultProductDescription");
      },
    },
    "settings"
  ),
  registerBulkAction(deleteBulkAction),
  registerBulkAction(noticeDeleteBulkAction),
  registerBulkAction(translationDeleteBulkAction),
  registerReactCustomDetailComponent({
    locationId: "product-detail",
    component: Spec,
  }),
];
